export default __webpack_public_path__ + "static/media/animat-checkmark-color.55e6eed1.gif";